import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  Textbox,
  BaseControl
} from '@app/shared';


@Injectable()
export class GroupsCheckboxFormService {
  constructor() { }

  /**
   * Retorna el formulario para agregar un grupo de checkbox
   *
   * @param {*} [data]
   * @returns {BaseControl<any>[]}
   * @memberof GroupsCheckboxFormService
   */
  getFormGroupCheckbox(data?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        order: 1,
        key: 'txtNombreGrupo',
        label: 'Nombre del grupo:',
        placeholder: 'Ingrese el nombre del grupo.',
        value: data ? data.nombre : null,
        validations: {
          validators: [Validators.required]
        },
      }),
      new Textbox({
        order: 2,
        key: 'numMinimo',
        type: 'number',
        label: 'Mínimo de cajas seleccionadas:',
        placeholder: 'Ingrese el mínimo de cajas seleccionadas.',
        validations: {
          validators: [Validators.min(0)],
          messages: {
            min: 'El mínimo de cajas seleccionadas no puede ser un número negativo'
          },
        },
        value: data ? data.min : null,
      }),
      new Textbox({
        order: 3,
        key: 'txtMensajeMinimo',
        label: 'Mensaje de alerta de selección mínima:',
        placeholder: 'Ingrese el mensaje de alerta para cuando la selección mínima de cajas no es válida.',
        value: data ? data.mensajeMin : null,
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'numMinimo',
            siEs: 'Vacio',
            accion: 'Ocultar'
          }
        ],
      }),
      new Textbox({
        order: 4,
        key: 'numMaximo',
        type: 'number',
        label: 'Máximo de cajas seleccionadas:',
        placeholder: 'Ingrese el máximo de cajas seleccionadas.',
        validations: {
          validators: [Validators.min(1)],
          messages: {
            min: 'El máximo de cajas seleccionadas no puede ser menor o igual a 0'
          },
        },
        value: data ? data.max : null,
      }),
      new Textbox({
        order: 5,
        key: 'txtMensajeMaximo',
        label: 'Mensaje de alerta de selección máxima:',
        placeholder: 'Ingrese el mensaje de alerta para cuando la selección máxima de cajas no es válida.',
        value: data ? data.mensajeMax : null,
        validations: {
          validators: [Validators.required]
        },
        condictions: [
          {
            campoDepende: 'numMaximo',
            siEs: 'Vacio',
            accion: 'Ocultar'
          }
        ],
      }),
    ];
    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/groups-checkbox/shared/groups-checkbox.form.service.ts